// Filename: /src/components/CommentSection/CommentForm.js

import React, { useState } from 'react';

const CommentForm = ({ onSubmit, placeholder = "Add a public comment...", cta = "Comment", onCancel }) => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;

    setIsLoading(true);
    await onSubmit(content);
    setIsLoading(false);
    setContent('');
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder={placeholder}
        disabled={isLoading}
        className="w-full bg-gray-900/70 border border-gray-700 text-white rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none transition disabled:opacity-50"
        rows="3"
      />
      <div className="flex justify-end gap-2">
        {onCancel && (
            <button
                type="button"
                onClick={onCancel}
                disabled={isLoading}
                className="px-3 py-1.5 rounded-md bg-gray-700 hover:bg-gray-600 text-xs font-semibold text-white transition disabled:opacity-50"
            >
                Cancel
            </button>
        )}
        <button
            type="submit"
            disabled={isLoading || !content.trim()}
            className="px-4 py-1.5 rounded-md bg-indigo-600 hover:bg-indigo-500 text-xs font-bold text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Posting...' : cta}
        </button>
      </div>
    </form>
  );
};

export default CommentForm;